import { Field, Label, Radio as RadioHeadless } from '@headlessui/react'
import { tv } from 'tailwind-variants'
import { Typography } from '../Typography'
import { Fragment } from 'react/jsx-runtime'

const tvRadio = tv({
  slots: {
    container:
      'group flex size-4 items-center justify-center rounded-full border border-gray-500',
    checkedContainer: 'size-1 rounded-full bg-white',
    text: 'text-gray-400 pointer-events-auto',
  },
  variants: {
    isChecked: {
      true: {
        container: 'border-gray-800 bg-primary-500',
      },
    },
    isDisabled: {
      true: {
        container: 'bg-gray-200',
      },
    },
  },
})

export function Radio({ value, label }: { value?: unknown; label: string }) {
  const { container, checkedContainer, text } = tvRadio()

  return (
    <Field className="flex cursor-pointer items-center gap-2">
      <RadioHeadless value={value}>
        {({ checked, disabled }) => {
          return (
            <span
              className={container({
                isChecked: checked,
                isDisabled: disabled,
              })}>
              {checked && (
                <span
                  className={checkedContainer({
                    isChecked: checked,
                    isDisabled: disabled,
                  })}
                />
              )}
            </span>
          )
        }}
      </RadioHeadless>
      <Label as={Fragment}>
        <Typography type="bodyOne" className={text()}>
          {label}
        </Typography>
      </Label>
    </Field>
  )
}
